// extracted by mini-css-extract-plugin
export default {"successButton":"SuccessStep_successButton__LZP-g"};